import { Placement } from '@popperjs/core';
import { Position, PositionStrict } from '@optimus-web/common';

export const getTooltipPositionFromPlacement = (placement?: Placement): PositionStrict => {
    if (placement) {
        return placement.split('-')[0] as PositionStrict;
    }

    // fallback
    return Position.Bottom;
};
